import { useEffect, useState } from "react";
import "./Category.css";
import Button from "@mui/material/Button";
import MuiTableWrapper from "../../components/common/mui-table-wrapper/MuiTableWrapper";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { del, get } from "../../common/network";
import { toast } from "react-toastify";
import FallbackGeneratedFormMessage from "../../components/common/fallback-form-message/FallbackGeneratedFormMessage";
import CollapseSearchField from "../../components/common/collapse-search-field/CollapseSearchField";
import AddNewCategory from "../../components/common/modal-preview/AddNewCategory";
import { useNavigate } from "react-router-dom";
import useSweetAlert from "../../components/common/alert/useSweetAlert";

const Category = () => {
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowsSelection, setRowsSelection] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [categories, setCategories] = useState([]);
    const [addNewModalOpen, setAddNewModalOpen] = useState(false);
    const sweetAlert = useSweetAlert();

    const fetchCategories = async () => {
        setIsFetching(true)
        try {
            const response = await get(`docgen/categories/`, {}, false);
            if (response?.status === 200) {
                setCategories(response?.data);
                setSelectedRows([]);
                setRowsSelection([]);
            }
        }
        catch (err) {
        }
        finally {
            setIsFetching(false)
        }
    }

    const handleDeleteCategory = async (categoryIds) => {
        try {
            const response = await del(`docgen/categories`, { categoryIds }, {}, false);
            if (response?.status === 200) {
                toast.success("Deleted Successfully");
                fetchCategories();
            }
        }
        catch (err) {
        }
    }

    const confirmCategoryDeletion = async (category) => {
        sweetAlert({
            title: "Please Confirm",
            text: `Would you like to delete '${category.name}'?`,
            icon: "warning",
            cancelButtonText: "No",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed == true) {
                handleDeleteCategory([category.id]);
            }
        });
    }

    const handleMultipleDelete = () => {
        sweetAlert({
            title: "Are you sure?",
            text: `Are you sure you want to delete the selected Category(ies)?`,
            icon: "warning",
            cancelButtonText: "No",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed == true) {
                const categoryIds = selectedRows?.map((row) => row.id);
                handleDeleteCategory(categoryIds);
            }
        });
    }

    const handleModalClose = () => {
        setAddNewModalOpen(false)
    }

    useEffect(() => {
        fetchCategories();
    }, [])


    const columns = [
        {
            field: "name",
            header: "Category Name",
            render: (value, row) => {
                return (
                    <div
                        style={{ textDecoration: "underline", cursor: "pointer", paddingTop: "0.5%", paddingBottom: "0.5%" }}
                        onClick={() => {
                            navigate(`/docgen/categories/form`, { state: { categoryId: row.id, categoryName: row?.name } });
                        }}>
                        {value}
                    </div>
                );
            }
        },
        {
            field: "id",
            header: "Actions",
            filter: false,
            sort: false,
            style: {
                textAlign: "center"
            },
            render: (value, row) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <DeleteOutlineIcon
                            onClick={() => confirmCategoryDeletion(row)}
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                );
            }
        }
    ];

    return (
        <div className="category">
            <div className="category-header">
                    <CollapseSearchField
                        searchText={searchText}
                        setSearchText={setSearchText}
                    />
                <div className="category-controls">
                    <section className="top-actions-section">
                        <div className="buttons-group">
                            <ul>
                                {
                                    Array.isArray(selectedRows) && selectedRows?.length > 0 &&
                                    <li style={{marginRight: "0.5rem"}}>
                                        <Button type="button" onClick={handleMultipleDelete}>
                                            <div className="icon-area">
                                                <DeleteOutlineIcon />
                                            </div>
                                            <p className="text-area">Delete</p>
                                        </Button>
                                    </li>
                                }
                            </ul>
                        </div>
                    </section>
                    <Button
                        variant="contained"
                        style={{ textTransform: 'none' }}
                        onClick={() => setAddNewModalOpen(true)}
                    >
                        Add New
                    </Button>
                </div>
            </div>
            <MuiTableWrapper
                columns={columns}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                emptyBody={<FallbackGeneratedFormMessage />}
                colgroup={[
                    { width: "90%" },
                ]}
                isFetching={isFetching}
                data={categories}
                searchValue={searchText}
                filterColumn={"all"}
                rowsSelection={rowsSelection}
                setRowsSelection={setRowsSelection}
            />
            <AddNewCategory
                openModal={addNewModalOpen}
                onClose={handleModalClose}
                callback={fetchCategories}
                categories={categories}
            />

        </div>
    );
};

export default Category;
